import {useContext} from 'react';
import {AdminContext} from 'contexts/admin';

export default function useAdmin() {
  const value = useContext(AdminContext);
  return value;
}
